export function formatDate(dateString) {
  const date = new Date(dateString);
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();

  return `${month} ${year}`;
}

export function formatDateTime(dateString) {
  const date = new Date(dateString);
  const today = new Date();

  const formattedDate = `${date.toLocaleDateString("bn", {
    weekday: "short",
  })}, ${date.toLocaleDateString("bn", {
    day: "numeric",
    month: "long",
  })}`;

  const formattedTime = date
    .toLocaleTimeString("bn", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    })
    .toLowerCase();

  const timeDifference = date.getTime() - today.getTime();
  const daysRemaining = Math.ceil(timeDifference / (1000 * 3600 * 24));

  const bnDigits = ["০", "১", "২", "৩", "৪", "৫", "৬", "৭", "৮", "৯"];
  const daysRemainingBn = Math.abs(daysRemaining)
    .toString()
    .split("")
    .map((digit) => bnDigits[parseInt(digit)])
    .join("");

  return {
    date: formattedDate,
    time: formattedTime,
    daysRemaining: daysRemainingBn,
  };
}

export function checkRemainingDays(publishedAt) {
  if (!publishedAt) return "0";
  const givenDate = new Date(publishedAt);
  const currentDate = new Date();

  if (givenDate < currentDate) {
    return "0";
  }

  const timeDifference = givenDate.getTime() - currentDate.getTime();
  return Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
}

export const getLocalDay = (schedule) => {
  const date = new Date(schedule);
  return date.toLocaleString("bn-BD", { weekday: "long" });
};

export const getLocalDate = (schedule) => {
  const date = new Date(schedule);

  return date.toLocaleString("bn-BD", {
    month: "long",
    day: "numeric",
  });
};

export const getLocalHour = (schedule) => {
  const date = new Date(schedule);

  const timeString = date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  const hours = date.getHours() % 12 || 12;
  const minutes = date.getMinutes();

  const bdTime = `${hours.toLocaleString("bn-BD")}:${minutes
    .toLocaleString("bn-BD")
    .toString()
    .padStart(2, "০")}`;

  const [time, meridian] = timeString.split(" ");
  const [hour] = time.split(":").map(Number);

  let banglaPeriod = "";

  if (meridian === "AM") {
    if (hour >= 5 && hour < 12) {
      banglaPeriod = "সকাল";
    } else {
      banglaPeriod = "রাত";
    }
  } else if (meridian === "PM") {
    if (hour >= 12 && hour < 3) {
      banglaPeriod = "দুপুর";
    } else if (hour >= 3 && hour < 6) {
      banglaPeriod = "বিকাল";
    } else {
      banglaPeriod = "রাত";
    }
  }

  // return `${banglaPeriod} ${hour}:${minute < 10 ? "0" + minute : minute} `;
  return `${banglaPeriod}  ${bdTime} `;
};
